<div id="content">
  <div id="left-section">
    <button
      id="alerts-back-button"
      mat-icon-button
      (click)="back()"
      aria-label="back"
      matTooltip="Back"
      matTooltipPosition="below"
      matTooltipClass="alert-custom-tooltip"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div id="heading">Manage Watch Alerts</div>
    <mat-slide-toggle
      id="disable-all-alerts"
      color="primary"
      class="toggle-track"
      labelPosition="before"
      [(ngModel)]="disableAll"
      (change)="onToggleChange($event.checked)"
    >
      Disable All Alerts
    </mat-slide-toggle>
  </div>
  <div id="right-section">
    <div id="filter-buttons">
      <button mat-button [ngClass]="{ active: true }">All</button>
      <button mat-button>Custom</button>
      <button mat-button>Product-Specific</button>
    </div>
    <div id="divider"></div>
    <button
      mat-flat-button
      color="primary"
      id="create-alert-btn"
      (click)="createNewAlertWindow()"
    >
      <mat-icon>add</mat-icon>
      <span>Create New Alert</span>
    </button>
  </div>
</div>
